import styled from "styled-components";

export const InputPaymentContainer = styled.label`
  display: flex;
  flex-direction: column;

  div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 0.5rem 0;
    width: 100%;
    gap: 0.75rem;

    @media (max-width: 425px) {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 0.5rem;
    }
  }

  p {
    color: rgba(67, 67, 67, 0.75);
    font-size: 0.875rem;
    line-height: 150%;
    text-align: right;
    font-weight: 700;
    width: 7.875rem;

    @media (max-width: 425px) {
      text-align: left;
      width: 100%;
    }
  }

  input {
    border: ${(props) =>
      props.errorCpf ? "1px solid red" : "1px solid #9E9E9E"};
    width: ${(props) => (props.width ? props.width : "max-content")};
    padding: 0.5rem 0.75rem 0.5rem 1rem;
    color: rgba(67, 67, 67, 0.75);
    font-size: 0.875rem;
    border-radius: 3px;
    line-height: 150%;
    font-weight: 400;
    height: 2.5rem;

    &:focus {
      border: none;
      outline: ${(props) =>
        props.errorCart ? "1px solid red" : "1px solid #9E9E9E"};
    }
  }

  span {
    color: #6bbfbf;
    font-size: 0.875rem;
    font-weight: 500;
  }

  .errorCart {
    color: red;
    font-size: 0.875rem;
    font-weight: 400;
    margin-left: 9rem;

    @media (max-width: 425px) {
      margin-left: 0;
    }
  }
`;
